import React from 'react';
import BasicEventVertex from "../../../../../mxGraph/HCLTreeNode/FaultTreeNode/BasicEventNode/BasicEventVertex";
import Label, {LabelJSON} from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Label";
import Expression, {ExpressionJSON} from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Expression";
import BasicEventVertexValue
  from "../../../../../mxGraph/HCLTreeNode/FaultTreeNode/BasicEventNode/BasicEventVertexValue";
import VertexSelectionDialog from "./VertexSelectionDialog";
import LabelInput from "../Inputs/LabelInput";
import ExpressionInput from "../Inputs/ExpressionInput";

interface Props {
  vertex: BasicEventVertex;
  onClose: () => void;
  onSave: () => void;
}

interface State {
  label: LabelJSON;
  expression: ExpressionJSON;
  labelError: boolean;
  expressionError: boolean;
}

class BasicEventSelectionDialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const { vertex } = this.props;
    const value = vertex.getValue() as BasicEventVertexValue;

    this.state = {
      label: value.getLabel().toJSON(),
      expression: value.getExpression().toExtendedJSON(),
      labelError: false,
      expressionError: false
    };
  }

  private handleSave = () => {
    const { vertex, onSave } = this.props;
    const { label, expression } = this.state;

    // save label
    const value = vertex.getValue() as BasicEventVertexValue;
    value.setLabel(Label.build(label));

    // save expression
    value.setExpression(new Expression(expression));
    console.log(value);

    onSave();
  };

  /**
   * handle input change of text fields
   * @param {Object} e - event object
   * @param {string} key - This tells us which text field the event is coming from.
   * @param {boolean} multiple - A flag should be set if the target contains multiple changes
   *  Specified by name field of {@link LabelInput} and {@link ExpressionInput}.
   */
  private handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    key: string,
    multiple?: boolean
  ) => {

    if(typeof e === 'string') {
      e = JSON.parse(e); // add `e` as a stringified object to have more control for expression output below
    } else {
      e.persist();
    }

    // change the entire object
    if (multiple) {
      // @ts-ignore
      this.setState(prevState => ({ [key]: { ...prevState[key], ...e.target.value } }));
    }
    // change a field
    else {
      // @ts-ignore
      this.setState(state => ({
        [key]: {
          // @ts-ignore
          ...state[key],
          [e.target.name]: e.target.value
        },
      }));
    }

  };

  private handleExpressionError = (error: boolean) => {
    this.setState({ expressionError: error });
  };

  private handleLabelError = (error: boolean) => {
    this.setState({ labelError: error });
  };

  render() {
    const { vertex, onClose } = this.props;
    const { label, expression, labelError, expressionError } = this.state;

    return (
      <VertexSelectionDialog
        vertex={vertex}
        onClose={onClose}
        onSave={this.handleSave}
        error={labelError || expressionError}
        open
        maxWidth="lg"
        fullWidth
      >
        <LabelInput
          label={Label.build(label)}
          onChange={this.handleChange}
          onError={this.handleLabelError}
          name="label"
          gridItemProps={{
            xs: 12,
            sm: 4,
          }}
        />
        <ExpressionInput
          expression={new Expression(expression)}
          onChange={this.handleChange}
          onError={this.handleExpressionError}
          name="expression"
        />
      </VertexSelectionDialog>
    );
  }
}

export default BasicEventSelectionDialog;
